/**
 * @deprecated
 * This file is deprecated and will be removed in future versions.
 * Use FeatureConfigContext instead for dynamic feature access control.
 * 
 * Migration: Replace getPageConfig(path) with useFeatureConfig().getFeature(featureKey)
 * 
 * New system will call backend API /feature-config/check/my-features to determine
 * feature access based on user data conditions (inventory, sales, shipment returns).
 */

// Config cho trạng thái đóng/mở các trang và thông báo
export const PAGE_STATUS_CONFIG = {
    // Kho hàng
    "kho-hang": {
        enabled: true,
        pageTitle: "kho hàng",
        notificationText: "cập nhật kho hàng",
        gradientColors: "from-purple-500 to-indigo-600",
        bgColors: "from-purple-50 to-indigo-100",
    },
    
    // Đơn hàng
    "don-hang": {
        enabled: true,
        pageTitle: "đơn hàng",
        notificationText: "quản lý đơn hàng",
        gradientColors: "from-blue-500 to-cyan-600",
        bgColors: "from-blue-50 to-cyan-100",
    },
    
    // Doanh số
    "doanh-so": {
        enabled: true,
        pageTitle: "doanh số",
        notificationText: "cập nhật doanh số",
        gradientColors: "from-purple-500 to-indigo-600",
        bgColors: "from-purple-50 to-indigo-100",
    },
    
    // Trả hàng
    "tra-hang": {
        enabled: true,
        pageTitle: "trả hàng",
        notificationText: "tạo phiếu trả hàng",
        gradientColors: "from-orange-500 to-red-600",
        bgColors: "from-orange-50 to-red-100",
    },
};

// Helper function để lấy config theo path
export const getPageConfig = (path) => {
    // Map các paths đến config keys
    const pathMap = {
        "/kho-hang": "kho-hang",
        "/kho-hang/chinh-sua": "kho-hang",
        "/don-hang": "don-hang",
        "/don-hang/tao-moi": "don-hang",
        "/don-hang/chinh-sua": "don-hang",
        "/doanh-so": "doanh-so",
        "/doanh-so/chinh-sua": "doanh-so",
        "/tra-hang": "tra-hang",
        "/tra-hang/chi-tiet": "tra-hang",
        "/tra-hang/tao-moi": "tra-hang",
        "/tra-hang/chinh-sua": "tra-hang",
        // Backward compatibility with old shipment-report paths
        "/shipment-reports": "tra-hang",
        "/shipment-report-detail": "tra-hang",
        "/shipment-report-form": "tra-hang",
    };
    
    const configKey = pathMap[path];
    return configKey ? PAGE_STATUS_CONFIG[configKey] : null;
};

